module.exports = __webpack_public_path__ + "img/Home-anli-4.cdc53652.png";